/* eslint-disable no-restricted-properties */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

// import { GridActionsCellItem } from "@mui/x-data-grid";
import moment from "moment";

export const formatDate = /* istanbul ignore next */ (date) => {
  const d = new Date(`${date}`);
  let month = `${d.getUTCMonth() + 1}`;
  let day = `${d.getUTCDate()}`;
  const year = d.getUTCFullYear();
  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  return [year, month, day].join("-");
};
export const getThisPeriod = () => {
  const thisPeriodStartDate = moment().startOf("month").format("YYYY-MM-DD");
  const thisPeriodEndDate = moment().endOf("month").format("YYYY-MM-DD");
  return {
    start: thisPeriodStartDate,
    end: thisPeriodEndDate,
  };
};
export function formatDateToYYYMMDD(date) {
  /* istanbul ignore next */
  const d = new Date(date);
  let month = `${d.getMonth()}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();
  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  return [year, month, day].join("-");
}
export function formatDateToYYYMMDD2(date) {
  /* istanbul ignore next */
  const d = new Date(date);
  let month = `${d.getMonth()}`;
  let day = `${d.getDate()}`;
  let year = d.getFullYear();
  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;
  if (month === "00") {
    month = 12;
    year = d.getFullYear() - 1;
  }
  return [year, month, day].join("-");
}
export const getYearlyPeriod = () => {
  const prevPeriodStartDate = moment()
    .subtract(1, "year")
    .endOf("year")
    .startOf("month")
    .subtract(3, "months")
    .format("YYYY-MM-DD");
  const prevPeriodEndDate = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");
  return {
    start: prevPeriodStartDate,
    end: prevPeriodEndDate,
  };
}; /* istanbul ignore next */
export const findTotalPercents = (
  totalUsage,
  prevData,
  isPrevNull,
  isCurrNull,
) => {
  const maxData = isPrevNull
    ? isCurrNull
      ? 0
      : totalUsage
    : totalUsage[2] > prevData[2]
    ? totalUsage
    : prevData;
  let totalMax = 0;
  let p10 = 0.1;
  let p50 = 0.5;
  let pMax = 1;
  let prefix = "GB";
  let prev = 0;
  let prevLabel = "";
  /* istanbul ignore next */
  if ((maxData[3] === 2 || maxData[3] === 1) && maxData[0] < 10) {
    totalMax = 1;
    p10 = 0.1;
    p50 = 0.5;
    pMax = 1;
  } else if ((maxData[3] === 2 || maxData[3] === 1) && maxData[0] > 10 < 100) {
    totalMax = 1;
    p10 = 0.1;
    p50 = 0.5;
    pMax = 1;
  } else if ((maxData[3] === 2 || maxData[3] === 1) && maxData[0] < 1000) {
    totalMax = 1;
    p10 = 0.1;
    p50 = 0.5;
    pMax = 1;
  } else if (maxData[3] === 3 && maxData[0] < 10) {
    totalMax = 10;
    p10 = 1;
    p50 = 5;
    pMax = 10;
    prefix = maxData[1];
  } else if (maxData[3] === 3 && maxData[0] >= 10 && maxData[0] < 100) {
    totalMax = 100;
    p10 = 10;
    p50 = 50;
    pMax = 100;
    prefix = maxData[1];
  } else if (maxData[3] === 3 && maxData[0] >= 100 && maxData[0] < 1000) {
    totalMax = 1000;
    p10 = 1000 / 10;
    p50 = totalMax / 2;
    pMax = 1000;
    prefix = maxData[1];
  } else if (maxData[3] === 3 && maxData[0] > 100) {
    totalMax = 1000;
    p10 = totalMax / 10;
    p50 = totalMax / 2;
    pMax = 1000;
  } else if (maxData[3] === 4 && maxData[0] < 100) {
    totalMax = 1000 * 100;
    p10 = 10;
    p50 = 50;
    pMax = 100;
    prefix = maxData[1];
  } else if (maxData[3] === 4 && maxData[0] > 100 && maxData[0] < 500) {
    totalMax = 1000 * 500;
    p10 = 50;
    p50 = 250;
    pMax = 500;
    prefix = maxData[1];
  } else if (maxData[3] === 4 && maxData[0] > 500 && maxData[0] < 1000) {
    totalMax = 1000 ** 2;
    p10 = 100;
    p50 = 500;
    pMax = 1000;
    prefix = maxData[1];
  } else if (maxData[3] === 5) {
    totalMax = 1000 ** 3;
    p10 = 100;
    p50 = 500;
    pMax = 1000;
    prefix = maxData[1];
  }
  prev = isPrevNull ? 0 : (prevData[2] / totalMax) * 100;
  prev = Number(Number.parseFloat(prev.toPrecision(3)));
  prevLabel = isPrevNull ? "NA" : `${prevData[0]} ${prevData[1]}`;
  let totalPercent = isCurrNull ? 0 : (totalUsage[2] / totalMax) * 100;
  totalPercent = Number(Number.parseFloat(totalPercent.toPrecision(3)));
  const totalPercentages = [
    { val: 0, prefix: "GB", max: totalMax },
    { val: p10, prefix, max: pMax },
    { val: p50, prefix, max: pMax },
    { val: pMax, prefix, max: pMax },
  ];
  return { totalPercent, totalPercentages, prev: { prev, prevLabel } };
};

export const bytesToSize = /* istanbul ignore next */ (bytes, val, powSize) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
  const unit = 1024;
  if (bytes === 0) return ["0", "Bytes", 0, 0];
  const exp = Math.floor(Math.log(bytes) / Math.log(unit));
  const result = bytes / unit ** exp;
  const resultGb = bytes / unit ** 3;
  powSize[val] = exp;
  if (bytes < unit)
    return [parseFloat((result / 1024).toPrecision(2)), "KB", resultGb, exp];
  if (result / 100 < 1)
    return [parseFloat(result.toPrecision(3)), sizes[exp], resultGb, exp];
  return [parseFloat(result.toPrecision(3)), sizes[exp], resultGb, exp];
};

export const titles = [
  {
    key: "status",
    label: "STATUS",
    sortable: true,
    sortKey: "end_date",
  },

  {
    key: "name",
    label: "NAME",
    sortable: true,
    sortKey: "display_name",
  },
  {
    key: "company",
    label: "Company",
    sortable: true,
    sortKey: "company_id",
  },
  {
    key: "startDate",
    label: "START DATE",
    sortable: true,
    sortKey: "start_date",
  },
  {
    key: "endDate",
    label: "END DATE",
    sortable: true,
    sortKey: "end_date",
  },
  {
    key: "collection",
    label: "COLLECTION",
    sortable: true,
    sortKey: "ingress",
  },
  // {
  //   key: "computation",
  //   label: "COMPUTATION"
  // },
  {
    key: "connection",
    label: "CONNECTION",
    sortable: true,
    sortKey: "egress",
  },
];
export const oldStandardTitles = [
  {
    key: "status",
    label: "STATUS",
    sortable: true,
    sortKey: "end_date",
  },

  {
    key: "name",
    label: "NAME",
    sortable: true,
    sortKey: "display_name",
  },
  {
    key: "company",
    label: "Company",
  },
  {
    key: "startDate",
    label: "START DATE",
    sortable: true,
    sortKey: "start_date",
  },
  {
    key: "endDate",
    label: "END DATE",
    sortable: true,
    sortKey: "end_date",
  },
  {
    key: "collection",
    label: "COLLECTION",
    sortable: true,
    sortKey: "ingress",
  },
  // {
  //   key: "computation",
  //   label: "COMPUTATION"
  // },
  {
    key: "connection",
    label: "CONNECTION",
    sortable: true,
    sortKey: "egress",
  },
];

export const standardTitles = [
  {
    key: "startDate",
    label: "Start Date ",
    sortable: true,
    sortKey: "startDate",
    width: "20%",
  },
  {
    key: "endDate",
    label: "End Date ",
    sortable: true,
    sortKey: "endDate",
    width: "20%",
  },
  {
    key: "usage",
    label: "Usage Fee",
    sortable: true,
    sortKey: "usageRate",
    width: "20%",
  },
  {
    key: "enrichment",
    label: "Enrichment",
    sortable: true,
    sortKey: "enrichmentTierCount",
    width: "20%",
  },
];

export const customTitles = [
  {
    key: "rateStatus",
    label: "Status ",
    sortable: true,
    sortKey: "startDate",
    width: "12%",
  },
  {
    key: "company",
    label: "Company ",
    sortable: true,
    sortKey: "company",
    width: "12%",
  },
  {
    key: "paymentType",
    label: "Payment Type ",
    sortable: true,
    sortKey: "paymentType",
    width: "12%",
  },
  {
    key: "startDate",
    label: "Start Date ",
    sortable: true,
    sortKey: "startDate",
    width: "17%",
  },
  {
    key: "endDate",
    label: "End Date ",
    sortable: true,
    sortKey: "endDate",
    width: "12%",
  },
  {
    key: "platformFee",
    label: "Platform Fee",
    sortable: true,
    sortKey: "platformFee",
    width: "13%",
  },
  {
    key: "usage",
    label: "Usage Fee",
    sortable: true,
    sortKey: "usageRate",
    width: "12%",
  },
  {
    key: "enrichment",
    label: "Enrichment",
    sortable: true,
    sortKey: "enrichmentTierCount",
    width: "5%",
  },
];

export const creditTitles = [
  {
    key: "dateTime",
    label: "Date",
  },
  {
    key: "description",
    label: "Description",
  },
  {
    key: "credits",
    label: "Credits",
  },
  {
    key: "balance",
    label: "Balance",
  },
];

export const billingHistoryTitles = [
  {
    key: "billingMonth",
    label: "Month",
  },
  {
    key: "collectionUsage",
    label: "Collection Usage",
  },
  {
    key: "connectionUsage",
    label: "Connection Usage",
  },
  {
    key: "totalUsage",
    label: "Total Usage",
  },
  {
    key: "creditsApplied",
    label: "Credits Applied",
  },
  {
    key: "enrichedMessagesCount",
    label: "Enrichment Count",
  },
  {
    key: "billingTotal",
    label: "Billing Total",
  },
  {
    key: "invoice",
    label: "Invoice",
  },
];

export const getListViewObj = (rates, companies) => {
  const reqCompany =
    companies &&
    companies.filter((company) => company.companyUUID === rates.companyId);
  const obj = {
    key: rates.id,
    status: {
      value: !(new Date(rates.startDate) <= new Date() && rates.endDate
        ? new Date(rates.endDate) >= new Date().setHours(0, 0, 0, 0)
        : true),
      future: new Date(rates.startDate) >= new Date(),
      view: "status",
    },
    name: {
      value: rates.displayName,
    },
    company: {
      value:
        reqCompany && reqCompany[0]
          ? reqCompany[0].companyName
          : rates.companyName
          ? rates.companyName
          : "standard",
      view: "company",
      data: rates.companyId,
    },
    startDate: {
      value: rates.startDate,
      view: "startDate",
    },
    endDate: {
      value: rates.endDate,
      view: "endDate",
    },
    collection: {
      value: rates.ingress,
      view: "collection",
    },
    connection: {
      value: rates.egress,
      view: "connection",
    },
    unitRate: {
      value: rates.unit,
    },
    // computation: {
    //   value: rates.internalCalculation,
    //   view: "computation"
    // }
  };
  return obj;
};

/* istanbul ignore next */
function getDates(startDate, stopDate) {
  const dateArray = [];
  const currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(
      `${`0${currentDate.getMonth() + 1}`.slice(
        -2,
      )}-${`0${currentDate.getDate()}`.slice(-2)}-${currentDate.getFullYear()}`,
    );
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dateArray;
}
/* istanbul ignore next */
function convertRegexFormat(timeFormat) {
  return timeFormat.replace(/(\d\d)-(\d\d)-(\d\d\d\d)/, "$3-$1-$2");
}
export const convertFullDateFormat = /* istanbul ignore next */ (
  data,
  startDate,
  endDate,
  billingParam,
) => {
  let lastDate;
  let firstDate;
  const timeZoneOffset = -8 * 60;
  const currentDate = moment(endDate).utcOffset(timeZoneOffset).toDate();
  const firstDay = moment(startDate).utcOffset(timeZoneOffset).toDate();
  const today = new Date();
  const monthDifference = currentDate.getMonth() - firstDay.getMonth();
  if (monthDifference > 0 && !billingParam) {
    lastDate = currentDate;
    firstDate = new Date(firstDay.getFullYear(), firstDay.getMonth(), 1);
    firstDay.setDate(firstDate.getDate());
  }
  if (monthDifference > 0 && billingParam) {
    lastDate = currentDate;
  }
  if (
    today.getMonth() === currentDate.getMonth() &&
    currentDate.getDate() > today.getDate()
  ) {
    lastDate = today;
  } else {
    lastDate = currentDate;
  }
  const clone = Object.assign([], data);
  const dates = getDates(firstDay, lastDate);
  const availabaleDates = clone.map((el) => el.date);
  const missingDates = dates.filter((el) => !availabaleDates.includes(el));
  for (let i = 0; i < missingDates.length; i++) {
    clone.push({
      date: missingDates[i],
      ingressData: 0,
      egressData: 0,
      internalCalculations: null,
    });
  }
  return clone.sort((a, b) => {
    const firstdate = convertRegexFormat(a.date);

    const secondDate = convertRegexFormat(b.date);
    return firstdate > secondDate ? 1 : secondDate > firstdate ? -1 : 0;
  });
};

export const totalUsageTimeFormator = /* istanbul ignore next */ (
  data,
  startDate,
) => {
  const currentDate = new Date();
  const firstDay = new Date(startDate);
  const clone = Object.assign([], data);
  const dates = getDates(firstDay, currentDate);
  const availabaleDates = clone.map((el) => el.day);
  const missingDates = dates.filter((el) => !availabaleDates.includes(el));
  for (let i = 0; i < missingDates.length; i++) {
    clone.push({ totalData: 0, day: missingDates[i] });
  }
  return clone.sort((a, b) => {
    const firstdate = convertRegexFormat(a.day);

    const secondDate = convertRegexFormat(b.day);
    return firstdate > secondDate ? 1 : secondDate > firstdate ? -1 : 0;
  });
};

export const getListObjStandardRates = (standardRates) => {
  const obj = {
    startDate: { value: standardRates.startDate },
    endDate: { value: standardRates.endDate ? standardRates.endDate : "n/a" },
    usage: {
      value: standardRates.usageRate,
    },
    enrichment: {
      value: standardRates.enrichmentTierCount,
    },
    rateStatus: { value: standardRates.status },
    config: { value: standardRates.id },
  };
  return obj;
};
export const TierRateTitles = [
  {
    key: "tier_rates",
    label: "Tier Rate",
    subTitle: "(per million messages)",
    editable: true,
    align: "left",
  },
  {
    key: "tier_min",
    label: "Tier Min",
    editable: false,
    align: "left",
  },
  {
    key: "tier_max",
    label: "Tier Max",
    editable: true,
    align: "left",
  },
];
export const getListObjCustomRates = (customRates) => {
  const obj = {
    company: { value: customRates.company },
    paymentType: { value: customRates.paymentType },
    startDate: { value: customRates.startDate },
    endDate: { value: customRates.endDate ? customRates.endDate : "n/a" },
    platformFee: { value: customRates.platformFee },
    usage: {
      value: customRates.usageRate,
    },
    enrichment: {
      value: customRates.enrichmentTierCount,
    },
    rateStatus: { value: customRates.status },
    config: { value: customRates.id },
  };
  return obj;
};
export const EnrichmentTierRates = {
  enrichmentTiers: [
    {
      tierRate: 50,
      tierMin: 0,
      tierMax: 15,
      deleteIcon: false,
    },
    {
      tierRate: 45,
      tierMin: 15,
      tierMax: 30,
      deleteIcon: true,
    },
    {
      tierRate: 40,
      tierMin: 30,
      tierMax: 50,
      deleteIcon: true,
    },
    {
      tierRate: 35,
      tierMin: 50,
      tierMax: 100,
      deleteIcon: true,
    },
    {
      tierRate: 30,
      tierMin: 100,
      tierMax: 150,
      deleteIcon: true,
    },
    {
      tierRate: 25,
      tierMin: 150,
      tierMax: 200,
      deleteIcon: true,
    },
    {
      tierRate: 20,
      tierMin: 200,
      tierMax: 300,
      deleteIcon: true,
    },
    {
      tierRate: 15,
      tierMin: 300,
      tierMax: null,
      deleteIcon: true,
    },
  ],
};

export const getMediatilorChartSeries = (series) => {
  const urlParams = new URLSearchParams(series?.config?.url);
  const fromDate = urlParams.get("from_date");
  const toDate = urlParams.get("to_date");
  const fromDateMoment = fromDate ? moment(fromDate) : null;
  const toDateMoment = toDate ? moment(toDate) : null;
  const updatedSeriesData = {};
  series?.data?.data?.forEach((item) => {
    if (!updatedSeriesData[item?.collectorConfigId]) {
      updatedSeriesData[item?.collectorConfigId] = {
        data: [],
        id: item?.collectorConfigId,
        name: item?.collectorConfigName,
        key: item?.collectorConfigId,
      };
    }
    updatedSeriesData[item?.collectorConfigId].data.push({
      x: moment(item?.date).startOf("day").valueOf(),
      y: item?.count,
    });
  });

  if (fromDateMoment && toDateMoment) {
    Object.values(updatedSeriesData).forEach((configData) => {
      const seriesDates = new Set(
        configData.data.map((item) => moment(item.x).format("YYYY-MM-DD")),
      );
      const currentDate = moment(fromDateMoment);
      const endDate = moment(toDateMoment);
      const allDates = [];

      while (currentDate.isSameOrBefore(endDate, "day")) {
        allDates.push(currentDate.format("YYYY-MM-DD"));
        currentDate.add(1, "day");
      }

      allDates.forEach((date) => {
        if (!seriesDates.has(date)) {
          configData.data.push({
            x: moment(date).startOf("day").valueOf(),
            y: 0,
          });
        }
      });
    });
  }

  Object.values(updatedSeriesData).forEach((configData) => {
    configData.data.sort((a, b) => a.x - b.x);
  });
  return Object.values(updatedSeriesData);
};

export const yAxisLabels = (val) => {
  const formatNumber = (num) => {
    return Number.isInteger(num) ? num.toString() : num.toFixed(1);
  };
  if (val < 100) {
    return formatNumber(val);
  }
  if (val >= 1000 && val < 1000000) {
    return `${formatNumber(val / 1000)}K`;
  }
  if (val >= 1000000) {
    return `${formatNumber(val / 1000000)}M`;
  }
  return formatNumber(val);
};

export const xAxisLabels = (startDate, endDate) => {
  startDate = moment(startDate);
  endDate = moment(endDate);

  const diffDays = endDate.diff(startDate, "days");
  const labels = [];
  const addedDates = new Set();

  const addFormattedLabel = (date) => {
    let formattedLabel = date.format("DD MMM");
    formattedLabel =
      formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
    if (!addedDates.has(formattedLabel)) {
      labels.push(formattedLabel);
      addedDates.add(formattedLabel);
    }
  };

  for (let i = 0; i <= diffDays; i++) {
    const labelDate = startDate.clone().add(i, "days");
    addFormattedLabel(labelDate);
  }
  return labels;
};

export const xAxisNoDataLabels = (startDate, endDate) => {
  startDate = moment(startDate);
  endDate = moment(endDate);

  const diffDays = endDate.diff(startDate, "days");
  const labels = [];
  const addedDates = new Set();

  const addFormattedLabel = (date) => {
    let formattedLabel = date.format("DD MMM");
    formattedLabel =
      formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
    if (!addedDates.has(formattedLabel)) {
      labels.push(formattedLabel);
      addedDates.add(formattedLabel);
    }
  };

  if (diffDays < 32) {
    for (let i = 0; i <= diffDays; i++) {
      const labelDate = startDate.clone().add(i, "days");
      addFormattedLabel(labelDate);
    }
  } else {
    const current = startDate.clone();
    while (current <= endDate) {
      addFormattedLabel(current);
      current.add(1, "week");
    }

    if (!addedDates.has(endDate.format("DD MMM"))) {
      addFormattedLabel(endDate);
    }
  }
  return labels;
};
